module.exports = __webpack_public_path__ + "static/media/illus-family.09f074d6.png";